import { useSetFollowupAppointmentBookedMutation } from "@/graphql/mutations/setFollowupAppointmentBooked.graphql.types";
import useErrorLogger from "@/utils/useErrorLogger";
import {
  CreateMultiProviderAppointmentProps,
  useCreateMultiProviderAppointment,
} from "./useCreateMultiProviderAppointment";

export const useRebookMultiProviderAppointment = ({
  configurationToUpdate,
  appointmentServices,
  client,
  telehealthType,
  telehealthVideoLink,
  telehealthAdditionalDetails,
  appointmentId,
}: CreateMultiProviderAppointmentProps & { appointmentId: string }) => {
  const logError = useErrorLogger();

  const handleCreateAppointment = useCreateMultiProviderAppointment({
    configurationToUpdate,
    appointmentServices,
    client,
    telehealthType,
    telehealthVideoLink,
    telehealthAdditionalDetails,
  });

  const [checkFollowupAppointmentBooked] =
    useSetFollowupAppointmentBookedMutation();

  const handleCreateRebookingAppointmentClick = async () => {
    try {
      const data = await handleCreateAppointment();

      if (appointmentId) {
        await checkFollowupAppointmentBooked({
          variables: {
            parentAppointmentId: appointmentId,
          },
          refetchQueries: ["AppointmentOverview"],
        });
      }

      return data;
    } catch (errors) {
      logError(`Exception while rebooking an appointment: ${errors}`);
    }
  };

  return handleCreateRebookingAppointmentClick;
};
